import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { DynamicImageView } from "components/common/DynamicImageView/DynamicImageView";

export const WeSupportBulkImageCompressionSection = ({ image }: { image?: string }) => {
    const finalImage = image || "/images/we_support_bulk_image_compression_preview.png";
    return (
        <div className={" flex flex-c ol md:flex-row items-center mt-20"}>
            <div className="flex-1 gap-2 hidden md:block">
                <DynamicImageView image={finalImage} alt={"We support bulk image compression sample image"} />
            </div>
            <div className="flex-1 dark:text-white text-center md:text-left">
                <h2 className="text-24 font-semibold ">
                    <Translate keyName="we-support-bulk-compression-title" />
                </h2>
                <p className="pt-1">
                    <Translate keyName="we-support-bulk-compression-subtitle" />
                </p>
                <div className="flex-1 gap-2  md:hidden">
                    <DynamicImageView image={finalImage} alt={"We support bulk image compression sample image"} />
                </div>
                <p className="md:pt-6">
                    <Translate keyName="we-support-bulk-compression-content" />
                </p>
            </div>
        </div>
    );
};
